<template>
  <v-navigation-drawer
    permanent
    width="300"
    class="primary menu-list"
    style="z-index: 11 !important"
    dark
    clipped
    app
    mini-variant
    expand-on-hover
    v-if="sideNav && sideNav.length > 0"
  >
    <v-list dense>
      <v-list-item v-for="(item, i) in sideNav" :key="i" class="pa-0 ma-0">
        <v-list-group
          v-if="item && item.subLinks && item.subLinks.length > 0"
          class="w-100 v-list-sub-group heading--text"
        >
          <template v-slot:activator>
            <v-list-item router exact>
              <v-list-item-action class="mr-2">
                <v-icon class="text-h6 font-weight-light">
                  {{ item.icon }}
                </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title style="text-transform: capitalize">
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item
            router
            v-for="(subItem, index) in item.subLinks"
            :key="index"
            :to="{ name: subItem.name }"
            :id="subItem.name"
            class="primary lighten-1 pr-2"
            active-class="subHeading--text"
          >
            <v-list-item-action class="ml-3">
              <v-icon class="text-h6 font-weight-light">
                {{ subItem.icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title style="text-transform: capitalize">
                {{ subItem.title }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <v-list-item
          v-else
          class="border-bottom-maroon"
          :to="{ name: item.name }"
          :id="item.name"
          router
          active-class="primary lighten-1 "
        >
          <v-list-item-action class="mr-2">
            <v-icon class="text-h6 font-weight-light">{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title style="text-transform: capitalize">
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item>

      <v-list-item @click="getDriverApp()" class="Full-Width">
        <v-list-item-action class="mr-2">
          <v-icon>mdi-download</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Download Driver APP</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { bus } from "@/main.js";
import {
  configurationModule,
  customerAddressModule,
  customerLocationUpdateModule,
  customerModule,
  fleetModule,
  itemModule,
  orderModule,
  tripModule,
  userModule,
} from "@/utils/moduleMapping";
import { mobileApk } from "@/utils/constants";
import { downloadFromUrl } from "@/utils/functions";

export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      adminMenu: [
        {
          icon: "mdi-view-dashboard",
          title: "Dashboard",
          name: "admin-dashboard",
        },
        {
          icon: "mdi-domain",
          title: "Companies",
          name: "company",
        },
        {
          icon: "mdi-account-credit-card-outline",
          title: "Account Managers",
          name: "account-manager",
        },
        {
          icon: "mdi-account-cog-outline",
          title: "Account Admins",
          name: "account-admin",
        },
        {
          icon: "mdi-account-cog-outline",
          title: "Subsciptions",
          name: "subsciption",
        },
        {
          icon: "mdi-bullhorn",
          title: "Announcements",
          name: "announcement",
        },
        {
          icon: "mdi-account-supervisor",
          title: "Support users",
          name: "support-user",
        },
        {
          icon: "mdi-account-tie",
          title: "Support",
          name: "support-user-ticket",
        },
        {
          icon: "mdi-form-textbox",
          title: "Custom Fields",
          name: "custom-field",
        },
        {
          icon: "mdi-cog-outline",
          title: "Configuration",
          key: "configuration",
          subLinks: [
            {
              icon: "mdi-truck-alert",
              title: "Vehicle Type",
              name: "vehicle-type",
            },
            {
              icon: "mdi-card-account-details",
              title: "License Type",
              name: "license-type",
            },
            {
              icon: "mdi-credit-card-multiple",
              title: "Permit Type",
              name: "permit-type",
            },
          ],
        },
      ],
      supportUser: [
        {
          icon: "mdi-view-dashboard",
          title: "Dashboard",
          name: "support-dashboard",
        },
        {
          icon: "mdi-account-tie",
          title: "Support",
          name: "support-ticket",
        },
      ],
      consigneeUser: [
        {
          icon: "mdi-view-dashboard",
          title: "Dashboard",
          name: "consignee-dashboard",
        },
        {
          icon: "mdi-truck-fast",
          title: tripModule.tripPlural,
          name: "consignee-trip",
          key: "trip",
        },
      ],
      accountManager: [
        {
          icon: "mdi-view-dashboard",
          title: "Dashboard",
          name: "admin-dashboard",
        },
        {
          icon: "mdi-domain",
          title: "Companies",
          name: "company",
        },
        {
          icon: "mdi-account-cog-outline",
          title: "Account Admins",
          name: "account-admin",
        },
      ],
      clientMenu: [
        {
          icon: "mdi-view-dashboard",
          title: "Dashboard",
          name: "client-dashboard",
          key: "dashboard",
        },
        {
          icon: "mdi-chart-scatter-plot",
          title: "Operational Analytics",
          name: "operation",
          key: "operation",
        },
        {
          icon: "mdi-calendar-edit",
          title: "Trips Planning",
          key: "trip_planning",
          subLinks: [
            {
              icon: "mdi-clipboard-list-outline",
              title: "Planning Templates",
              name: "trip-planning-template",
            },
            {
              icon: "mdi-tanker-truck",
              title: "Trip Plans",
              name: "trip-planning",
            },
            {
              icon: "mdi-vector-polygon-variant",
              title: "Driver Zones",
              name: "driver-zone",
            },
            {
              icon: "mdi-artboard",
              title: "Region Restrictions",
              name: "region-restriction",
            },
            {
              icon: "mdi-alpha-t",
              title: "Tags",
              name: "tags",
            },
          ],
        },
        {
          icon: "mdi-truck-fast",
          title: tripModule.tripPlural,
          name: "trip-new",
          key: "trip",
        },
        {
          icon: "mdi-archive",
          title: orderModule.orderPlural,
          name: "order-new",
          key: "order",
        },
        // {
        //   icon: "mdi-archive",
        //   title: orderModule.orderPlural,
        //   key: "order",
        //   subLinks: [
        //     {
        //       icon: "mdi-alpha-s-box",
        //       title: orderModule.sales,
        //       name: "sale-order-new",
        //     },
        //     {
        //       icon: "mdi-alpha-a-box",
        //       title: orderModule.adhoc,
        //       name: "adhoc-order-new",
        //     },
        //   ],
        // },
        {
          icon: "mdi-radio-fm",
          title: "Asset Management",
          key: "fleet",
          subLinks: [
            {
              icon: "mdi-account-tie-hat",
              title: fleetModule.driverPlural,
              name: "driver-list",
            },
            {
              icon: "mdi-truck-outline",
              title: fleetModule.vehiclePlural,
              name: "vehicle-list",
            },
          ],
        },
        {
          icon: "mdi-account-multiple",
          title: `${customerModule.customer} Management`,
          key: "customer",
          subLinks: [
            {
              icon: "mdi-account",
              title: customerModule.customerPlural,
              name: "customer-list",
            },
            {
              icon: "mdi-map-marker-outline",
              title: customerAddressModule.customerAddressPlural,
              name: "customer-address-list",
            },
            {
              icon: "mdi-map-marker-check-outline",
              title: customerLocationUpdateModule.customerLocationUpdate,
              name: "customer-location-update-list",
            },
          ],
        },
        {
          icon: "mdi-alpha-i-circle",
          title: itemModule.itemPlural,
          key: "item",
          name: "item-list",
          // subLinks: [
          //   {
          //     icon: "mdi-weight-kilogram",
          //     title: "Item Unit",
          //     to: "/app/client/item-unit",
          //   },
          // ],
        },
        {
          icon: "mdi-account-group",
          title: userModule.userPlural,
          key: "user",
          name: "user-list",
        },
        {
          icon: "mdi-account-supervisor-circle",
          title: "Consignees",
          key: "user",
          name: "consignee-management",
        },
        {
          icon: "mdi-cog-outline",
          title: "Configurations",
          key: "configuration",
          subLinks: [
            {
              icon: "mdi-source-branch",
              title: configurationModule.branchManagement,
              name: "branch",
            },
            {
              icon: "mdi-alpha-p-box",
              title: configurationModule.projectPlural,
              name: "project",
            },
            {
              icon: "mdi-warehouse",
              title: configurationModule.warehousePlural,
              name: "warehouse-list",
            },
            {
              icon: "mdi-account-group",
              title: configurationModule.integrationPartnerPlural,
              name: "integration-partner-list",
            },
            {
              icon: "mdi-table-cog",
              title: configurationModule.fieldConfigurationPlural,
              name: "field-configuration",
            },

            {
              icon: "mdi-currency-usd",
              title: configurationModule.paymentMethodPlural,
              name: "payment-method",
            },
            {
              icon: "mdi-card-account-details",
              title: configurationModule.rolePlural,
              name: "role",
            },
            {
              icon: "mdi-key",
              title: configurationModule.apiTokenPlural,
              name: "api-token",
            },
            {
              icon: "mdi-archive-settings-outline",
              title: configurationModule.storageTypePlural,
              name: "storage-type",
            },
            
          ],
        },
        {
          icon: "mdi mdi-archive-edit",
          title: "Integration",
          key: "integration",
          subLinks: [
            {
              icon: "mdi mdi-archive-edit",
              title: "Integration Logs",
              name: "integration-logs",
            },
            {
              icon: "mdi-file-document-alert",
              title: "Integration Docs",
              name: "integration-docs",
            },
          ],
        },
        {
          icon: "mdi-clipboard-file",
          title: "Reports",
          name: "reports",
          key: "report",
        },
        {
          icon: "mdi-account-tie",
          title: "Support",
          name: "support",
          key: "configuration",
        },
      ],
      userType: null,
      currentProfile: null,
      sideNav: [],
      groupOpened: [],
    };
  },
  computed: {
    drawer: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    loadNavMenu() {
      let userData = this.$helper.getUserDetailsLocalStorage();
      let permissions = userData.permissions;
      let interval = setInterval(() => {
        if (userData) {
          clearInterval(interval);
          if (userData.role == "system_admin") {
            this.sideNav = this.adminMenu;
          } else if (userData.role == "support_user") {
            this.sideNav = this.supportUser;
          } else if (userData.role == "consignee_user") {
            // this.sideNav = this.consigneeUser;
          } else if (userData.role == "account_manager") {
            this.sideNav = this.accountManager;
          } else {
            this.sideNav = this.clientMenu.filter((mod) => {
              if (
                mod.key == "dashboard" ||
                (permissions[mod.key] && permissions[mod.key]["view"])
              ) {
                return mod;
              }
            });
          }
        }
      });
    },
    getDriverApp() {
      this.$api.driver
        .getDriverAppDownload()
        .then((res) => {
          downloadFromUrl(res.data.apk_file);
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  async mounted() {
    await this.loadNavMenu();
  },
};
</script>

<style lang="scss">
.v-list-sub-group .border-bottom-maroon {
  border: none !important;
}

.v-list-sub-group {
  .v-list-group__header {
    padding: 0 !important;
  }
}

.menu-list
  .v-list-group
  > .v-list-group__header
  > .v-list-group__header__append-icon
  .v-icon {
  margin: 6px;
}
</style>
